import { useMemo } from 'react';
import { GridRow, GridRowProps } from '@mui/x-data-grid-pro';

import Tooltip from 'components/shared/Tooltip';
import { SummaryCard } from 'components/mrp/components/SummaryCard';

import { EventResponse } from 'generated/index';

import { convertEventResponseToCalendarEvent } from './AppointmentRowTooltip.utils';

type AppointmentRowTooltipProps = {
  event: EventResponse | undefined;
  gridRow: GridRowProps;
};

const AppointmentRowTooltip = ({
  event,
  gridRow
}: AppointmentRowTooltipProps) => {
  const calendarEvent = useMemo(
    () => (event ? convertEventResponseToCalendarEvent(event) : null),
    [event]
  );

  if (!calendarEvent) return <GridRow {...gridRow} />;

  return (
    <Tooltip
      arrow
      enterDelay={100}
      enterNextDelay={100}
      title={<SummaryCard event={calendarEvent} interactable={false} />}
    >
      <GridRow {...gridRow} />
    </Tooltip>
  );
};

export default AppointmentRowTooltip;
